<template>
  <div>
    <SellHeader :img_header="header_image" header="คำสั่งซื้อ" link_back="sell/ordercustomermain"/>
    <Confirm_customer_detail/>
  </div>
</template>

<script>
import SellHeader from "@/components/admin/sell/header_sell/SellHeader";
import HeaderImage from "@/assets/agreement.png";
import Confirm_customer_detail from "@/components/admin/sell/Confirm_customer_detail";
export default {
  name: "ConfirmCustomerDetail",
  components: {
    Confirm_customer_detail,
    SellHeader
  },
  data() {
    return {
      header_image: HeaderImage
    }
  }
}
</script>

<style scoped>

</style>
